import {BrowserModule} from "@angular/platform-browser";
import {NgModule} from "@angular/core";
import {AppRoutingModule} from "./app-routing.module";
import {AppComponent} from "./app.component";
import {LoginComponent} from "./login/login.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {ForgetPasswordComponent} from './login/forget-password/forget-password.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LottieModule} from 'ngx-lottie';
import player from 'lottie-web';
import {ModalModule} from "ngx-bootstrap/modal";
import {ReqInterceptorService} from "./services/req-interceptor.service";
import {CustomToastComponent} from "./dashboard/query-management/custom-toast/custom-toast.component";
import {ToastrModule} from "ngx-toastr";
import {ListFilterPipe} from "angular2-multiselect-dropdown";
import {ɵm as DataService} from "angular2-multiselect-dropdown";
import {AngularMultiSelectModule} from 'angular2-multiselect-dropdown';

export function playerFactory() {
  return player;
}


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForgetPasswordComponent,
    CustomToastComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    LottieModule.forRoot({player: playerFactory}),
    ModalModule.forRoot(),
    ToastrModule.forRoot({toastComponent: CustomToastComponent}),
    AngularMultiSelectModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ReqInterceptorService,
      multi: true
    },
    ListFilterPipe,
    DataService
  ],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}

// "@chenfengyuan/datepicker": "^1.0.9",
// "icheck": "^1.0.2",
// "ngx-checkbox": "0.0.8",
// "ng-multiselect-dropdown": "^0.2.10",
// "@progress/kendo-angular-common": "^3.2.2",
// "@progress/kendo-angular-pdf-export": "^4.0.1",
// "@progress/kendo-drawing": "^1.17.2",
// "@progress/kendo-theme-default": "^5.12.0",
// "hammerjs": "^2.0.8",
// "@mobiscroll/angular-lite": "^4.10.9",
// "jspdf": "^2.4.0",
// "html-docx-js-typescript": "latest",

